// extracted by mini-css-extract-plugin
export var addressFields = "_k5-0";
export var animationContainer = "_k5-1";
export var footer = "_k5-2";
export var lineItems = "_k5-3";
export var modalContent = "_k5-4";
export var orderName = "_k5-5";
export var strong = "_k5-6";
export var warning = "_k5-7";